/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import bnd3Service from '../../../services/bnd3.service';
import utilityService from '../../../services/utility.service';
import ChartConst from '../../../constants/chart.constant';
import AppConst from '../../../constants/app.constant';
import d3 from '../../../globalexports/d3.export';
import { getTempLabelValue } from '../../../services/chartData/getTempLabelValue';

function temperatureStripService() {
  const content = {};
  content.drawTemperatureStrip = (
    sourceData,
    chartObj,
    width,
    topSpace,
    x,
    xAxisAndChartDistance,
    temperatureUnit,
    normalTextHeight,
    xKey,
    mode,
    softDraw,
  ) => {
    const rectRadius = 2;

    if (!sourceData) {
      return;
    }
    // Setting Domain for X-axis
    x.domain(d3.extent(sourceData, (d) => d[xKey]));
    if (!softDraw) {
      // X-Axis strip
      chartObj
        .append('rect')
        .attr('height', normalTextHeight * 2 + 4)
        .attr('width', width)
        .attr('y', -normalTextHeight)
        .attr('fill', '#fff');
    }
    const temperatureStrip = chartObj.selectAll('g').data(sourceData).enter();
    const airportTemp = temperatureStrip
      .append('g')
      .attr('class', (d) => (mode === AppConst.dataMode.meteogram ? '' : `${'airport-stop airportStop-'}${d.icao_id}`))
      .attr('id', (d) => (mode === AppConst.dataMode.meteogram ? '' : `airportStop-temp-${d.icao_id}`))
      .attr('transform', (d) => {
        const xValue = x(d[xKey]);
        return `translate(${xValue}, 0)`;
      });
    if (!softDraw) {
      // This rectangle by default is invisible i.e. opacity:0
      // This rect will be shown when tooltip is shown as dark background
      airportTemp
        .append('rect')
        .attr('class', mode === AppConst.dataMode.meteogram ? 'temp-rect' : 'airport-stop-rect')
        .attr('rx', rectRadius)
        .attr('ry', rectRadius);
    }
    airportTemp
      .append('text')
      .text((d) => getTempLabelValue(
        temperatureUnit,
        d.tmp_celsius,
        d.tmp_fahrenheit,
        true,
      ))
      .attr('style', 'text-anchor: middle;')
      .attr('y', 0);
    airportTemp
      .append('text')
      .text(
        (d) => (d.rlh || ChartConst.noValueText) + (mode === AppConst.dataMode.meteogram ? '%' : '% RH'),
      )
      .attr('style', 'text-anchor: middle')
      .attr('y', normalTextHeight);
    if (!softDraw) {
      airportTemp
        .select('rect')
        .attr('height', () => normalTextHeight * 2 + 2)
        .attr('width', (...args) => {
          const selfEle = utilityService.getSelfElement(args);
          return bnd3Service.getMaxTextWidth(d3.select(selfEle.parentNode)) + 4;
        })
        .attr('transform', (...args) => {
          const selfEle = utilityService.getSelfElement(args);
          const xValue = bnd3Service.getMaxTextWidth(d3.select(selfEle.parentNode)) + 4;
          const y = -(normalTextHeight - 2);
          return `translate(${-(xValue / 2)}, ${y})`;
        });
    }
    chartObj
      .append('rect')
      .attr('class', 'clear-rect')
      .attr('x', -1)
      .attr('y', normalTextHeight + xAxisAndChartDistance)
      .attr('width', width + 2)
      .attr('height', topSpace / 2);
  };
  return content;
}
export default temperatureStripService();
